// extracted by mini-css-extract-plugin
export default {"PageContainer":"WelcomePage_PageContainer__JjgIK","ContentContainer":"WelcomePage_ContentContainer__onbEg","Image":"WelcomePage_Image__pWS7S"};